import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

const MobileStackedCards = () => {
    const containerRef = useRef(null);

    useGSAP(() => {
        const cards = gsap.utils.toArray('.mobile-card');
        
        // نلف على كل الكروت ما عدا الكارت الأخير
        cards.forEach((card, index) => {
            if (index === cards.length - 1) return;

            gsap.to(card, {
                // تأثير العمق: الكارت الحالي يصغر ويختفي تدريجياً ليتيح القمة للكارت التالي
                scale: 0.88,
                opacity: 0.6,
                blur: 5,
                scrollTrigger: {
                    trigger: card,
                    start: "top 12%", // يبدأ التأثير أول ما الكارت يقرب من أعلى الشاشة
                    end: "bottom 12%",
                    scrub: true,      // مربوط بصباع المستخدم وهو بيعمل سكرول
                    pin: true,        // تثبيت الكارت الحالي في مكانه ليصعد القادم فوقه
                    pinSpacing: false // منع الفراغات البيضاء لضمان التراكم
                }
            });
        });
    }, { scope: containerRef });

    const services = [
        { id: 1, title: "مشروع منصة تعليميه متكامله", bg: "#1e1b4b", des:"منصه تعليميه تتكون من ٥ اصدارات مختلفه كل إصدار له عدة ميزات من البسيط تماماً حتى الخوارزميات الذكيه لتتبع حالة الطالب و قيادة العمليه التعليميه بالكامل"},
        { id: 2, title: "إدارة الشبكات", bg: "#311042", des:"مشروع إدارة الشبكه بهدف التربح منها من خلال توزيع الإنترنت و السيطره عليه تماماً بنظام خاص مبنى من الصفر يمكن من خلاله التوسع لخدمات شبكيه أخرى تعود بالنفع و الفائده علي المؤسسه" },
        { id: 3, title: "تصميم البرمجيات بالطلب", bg: "#062f4f", des:"يمكنكم في اي وقت طلب خدمه مخصصه تماماً لما يتناسب مع المؤسسه الخاصه بكم لحل مشكله محدده او تقديم خدمه خاصه جداً"}
    ];

    return (
        <div ref={containerRef} style={{ background: '#0b0c10', padding: '20px 0', direction:"rtl" }}>
            <h2 style={{ textAlign: 'center', color: 'white', padding: '40px 0' }}>منتجات ساسكي الذكية</h2>
            
            {services.map((svc) => (
                <div key={svc.id} className="mobile-card" style={{...cardStyle, backgroundColor: svc.bg}}>
                    <span style={{ fontSize: '2rem' }}>0{svc.id}</span>
                    <h3>{svc.title}</h3>
                    <p style={{ color: '#9ca3af', fontSize: '0.9rem' }}>{svc.des}</p>
                    <button style={{ ...btnStyle }}>اكتشف المزيد ↗</button>
                </div>
            ))}
            
            {/* سكشن وهمي تحتهم لضمان وجود مساحة سكرول بعد الكروت */}
            <div style={{ height: '50vh' }} />
        </div>
    );
};

// ستايل الكارت المناسب لشاشة الموبايل
const cardStyle = {
    width: '90%',
    height: '380px',
    margin: '0 auto 40px auto',
    borderRadius: '24px',
    padding: '30px',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: '0 -10px 20px rgba(0,0,0,0.3)',
    border: '1px solid rgba(255,255,255,0.05)',
    position: 'relative'
};

const btnStyle = {
    padding: '12px', background: 'rgba(255,255,255,0.1)', border: 'none', 
    borderRadius: '12px', color: 'white', fontWeight: 'bold'
};

export default MobileStackedCards;